<template>
  <div class="home">
    <div class="header">
      <div class="header-box header-left">
        <div class="home-btn hover-btn" @click="toOneMenu">
          <a>首页</a>
          <img class="home-btn-icon" src="../../assets/btn.png"/>
        </div>
        <div class="navigation-btn hover-btn" @click="toOneMenu">
          <a>导航</a>
          <img class="nav-btn-icon" src="../../assets/btn.png"/>
        </div>
<!--        <div class="search-btn">-->
<!--          <input placeholder="请输入关键字"/>-->
<!--          <img class="search-btn-icon" src="../../assets/search.png"/>-->
<!--        </div>-->
      </div>
      <div class="header-center">原料智能仓储综合管理平台</div>
      <div class="header-box header-right">
<!--        <img class="notice-btn-icon button" src="../../assets/notice.png"/>-->
        <div class="time-btn">
          <a>{{time}}</a>
          <img class="time-btn-icon" src="../../assets/time.png"/>
        </div>
        <div class="time-btn" style="justify-content: flex-end">
          <div class="user-info">
            <div class="welcome">您好！</div>
            <div class="name" @click="showChange = true">{{this.userInfo.name || '-'}}</div>
          </div>
          <a class="exit" @click="toLogin">退出</a>
          <img class="time-btn-icon" src="../../assets/time.png"/>
        </div>
      </div>
    </div>
    <router-view></router-view>
    <transition name="fade">
      <div class="alert-box" v-if="showChange">
        <div class="alert-content" style="width: auto">
          <div class="alert-content-title">修改密码</div>
          <div class="input-contain" style="margin: 0.5vw 0">
            <div class="input-title" style="padding-left: 1.78vw">旧密码：</div>
            <div class="input-wrapper">
              <input type="password" placeholder="" v-model="changeData.oldPassword"/>
            </div>
          </div>
          <div class="input-contain" style="margin: 0.5vw 0">
            <div class="input-title" style="padding-left: 1.78vw">新密码：</div>
            <div class="input-wrapper">
              <input type="password" placeholder="" v-model="changeData.newPassword"/>
            </div>
          </div>
          <div class="input-contain" style="margin: 0.5vw 0 1vw 0">
            <div class="input-title">确认新密码：</div>
            <div class="input-wrapper">
              <input type="password" placeholder="" v-model="changeData.confirmNewPassword"/>
            </div>
          </div>
          <div class="alert-content-btn">
            <div class="btn-cancel button" @click="cancelChange">取消</div>
            <div class="btn-confirm button" @click="confirmChange">确认</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { logOut, updateUserPassword } from '../../api/login'
import { noEmpty } from '../../tools/methods'
import localforage from 'localforage'
import AES from '../../tools/AES'
export default {
  name: 'Home',
  data () {
    return {
      time: '',
      userInfo: '',
      showChange: false,
      changeData: {
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: ''
      }
    }
  },
  created () {
    let that = this
    that.nowTime()
    setInterval(function () {
      that.nowTime()
    }, 1000)
    localforage.getItem('user_Info').then(res => {
      this.userInfo = res.user_info
    })
  },
  methods: {
    nowTime: function () {
      // 获取年月日
      let time = new Date()
      let year = time.getFullYear()
      let month = time.getMonth() + 1
      let day = time.getDate()

      // 获取时分秒
      let h = time.getHours()
      let m = time.getMinutes()
      let s = time.getSeconds()

      // 检查是否小于10
      month = this.check(month)
      day = this.check(day)
      h = this.check(h)
      m = this.check(m)
      s = this.check(s)
      this.time = year + '-' + month + '-' + day + ' ' + h + ':' + m + ':' + s
    },
    check: function (i) {
      let num
      i < 10 ? num = '0' + i : num = i
      return num
    },
    toOneMenu: function () {
      this.$router.push({
        path: '/oneMenu'
      })
    },
    toLogin: function () {
      logOut().then(res => {
        console.log(res)
        this.$router.push({
          path: '/'
        })
        this.$message({
          message: '退出成功!',
          type: 'success',
          center: 'true',
          duration: '1000',
          customClass: 'login-message'
        })
      }).catch(err => {
        console.log(err)
      })
    },
    confirmChange: function () {
      if (
        noEmpty(this.changeData.oldPassword, '请输入旧密码', 'login-message') &&
        noEmpty(this.changeData.newPassword, '请输入新密码', 'login-message') &&
        noEmpty(this.changeData.confirmNewPassword, '请输入确认新密码', 'login-message')
      ) {
        if (this.changeData.newPassword !== this.changeData.confirmNewPassword) {
          this.$message({
            message: '新密码与确认新密码不一致!',
            type: 'warning',
            center: 'true',
            customClass: 'login-message',
            duration: '1000'
          })
        } else {
          let body = {
            oldPassword: AES.encrypt(this.changeData.oldPassword, 'onWwdDEUMfBKC1zl'),
            newPassword: AES.encrypt(this.changeData.newPassword, 'onWwdDEUMfBKC1zl')
          }
          updateUserPassword(body).then(res => {
            console.log(res)
            this.showChange = false
            this.changeData = {
              oldPassword: '',
              newPassword: '',
              confirmNewPassword: ''
            }
            this.$message({
              message: '修改成功!',
              type: 'success',
              center: 'true',
              customClass: 'login-message',
              duration: '1000'
            })
          }).catch(err => {
            console.log(err)
          })
        }
      }
    },
    cancelChange: function () {
      this.showChange = false
      this.changeData = {
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: ''
      }
    }
  }
}
</script>

<style scoped>
  @import "Home.css";
</style>



// WEBPACK FOOTER //
// src/page/oneMenu/Home.vue